/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";
import { getAthenaTenants } from "lib/services/athenaTenants";
import { Autocomplete } from "@material-ui/lab";
import { TextField, CircularProgress } from "@material-ui/core";

export default function AthenaTenantsAutocomplete({
  selectedAthenaTenants = [],
  inputProps = {},
  onChange
}) {
  const [athenaTenants, setAthenaTenants] = React.useState([]);
  const [fetched, setFetched] = React.useState();
  const [open, setOpen] = React.useState(false);
  const loading = open && !fetched && !athenaTenants.length;

  const fetchAndSetAthenaTenants = async () => {
    const result = await getAthenaTenants();
    setAthenaTenants(result.data);
    setFetched(true);
  };

  React.useEffect(() => {
    if (loading) fetchAndSetAthenaTenants();
  }, [loading]);

  const handleChange = (_e, value) => {
    if (onChange) onChange(value);
  };

  return (
    <Autocomplete
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      loading={loading}
      options={athenaTenants}
      getOptionLabel={option => option.mysql_database}
      getOptionSelected={(option, value) => option.id === value.id}
      defaultValue={selectedAthenaTenants}
      filterSelectedOptions
      onChange={handleChange}
      renderInput={params => {
        const props = { ...params, ...inputProps };
        return (
          <TextField
            {...props}
            placeholder="Tenants"
            InputProps={{
              ...params.InputProps,
              ...inputProps.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        );
      }}
    />
  );
}
